import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaForm from 'Components/ComponentLibrary/Organisms/MetaForm';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Fade from '@mui/material/Fade';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import Layout from './Layout';

const styles = () => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formContainer: {
    width: '1000px',
    maxWidth: '1000px',
    flexDirection: 'row',
  },
});

const Form = ({
  className,
  classes,
  collection,
}) => {
  return (
    <Fade in timeout={300}>
      <Box className={classNames(classes.root, className)}>
        <MetaForm
          className={classNames(classes.formContainer)}
          collection={collection}
          metaOverrideSet={BaseOverrideNoHidden}
          layout={Layout}
        />
      </Box>
    </Fade>
  );
};

Form.defaultProps = {
  className: '',
};

Form.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
};

export default withStyles(styles)(Form);
